import React from "react";
import { Navigate } from "react-router-dom";
import { usePerms } from "@/PermissionContext";

export default function RequireSuperAdminRoute({ children }) {
  const { isSuperAdmin, ready } = usePerms();
  if (!ready) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!isSuperAdmin) return <Navigate to="/profile" replace />;
  return children;
}
